import { gql } from '@apollo/client';

export const DELETE_SITE_IMAGE_MUTATION = gql`
  mutation DeleteSiteImageMutation($siteId: String!, $imageId: String!) {
    deleteSiteImage(siteId: $siteId, imageId: $imageId) {
      ... on UpdateSiteSuccess {
        site {
          id
          image
          imageCropPosition {
            x
            y
          }
          images
          updatedAt
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
